module.exports = __webpack_public_path__ + "static/adv3-71eb0982731814561a4356f3b66b4a3c.png";